import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';
import './assets/scss/style.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  i18n,
}).$mount('#app');
